import { createThemeCompiler } from '../../../utils';

export const messageThemeCompiler = createThemeCompiler(({ palette }) => ({
    message: {
        colors: {
            errorMessageColor: palette.red,
            informationMessageColor: palette.blueMid,
            successMessageColor: palette.green,
            warningMessageColor: palette.orangeLight
        }
    }
}));
